export default {
  API_URL: 'https://eden.g-rexjapan.co.jp/api',
  GUIDE_URL: './docs/UsersGuide.pdf',
  PRODUCT_NAME: '電子ブック作成システム',
  HEADER_HEIGHT: 61,
  FOOTER_HEIGHT: 61,
  MESSAGE: {
    TIMEOUT: 'セッションがタイムアウトしました。再度ログインしてください。'
  },
  EDITOR_CONFIG: {
    language: 'ja',
    branding: false, // クレジット非表示
    elementpath: false, // フォーカスした要素のタグ非表示
    forced_root_block: false, // Enterで改行
    height: 250,
    element_format: 'html',
    file_picker_types: 'image',
    image_title: true,
    plugins: 'image table preview pagebreak hr textcolor',
    toolbar: 'undo redo | styleselect | bold italic | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image | stylselect',
    fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
    style_formats_merge: true,
    style_formats: [
      {
        title: '左に回り込み',
        selector: 'img',
        styles: {
          'float': 'left',
          'margin': '0 10px'
        }
      },
      {
        title: '右に回り込み',
        selector: 'img',
        styles: {
          'float': 'right',
          'margin': '0 10px'
        }
      }
    ],
    mobile: {
      theme: 'mobile',
      plugins: [ 'autosave', 'lists', 'autolink' ],
      toolbar: [ 'undo', 'bold', 'italic', 'styleselect' ]
    }
  },
  EDITOR_CONFIG_FILEPICKER_CALLBACK: function (cb, value, meta) {
    var input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')

    // Note: In modern browsers input[type="file"] is functional without
    // even adding it to the DOM, but that might not be the case in some older
    // or quirky browsers like IE, so you might want to add it to the DOM
    // just in case, and visually hide it. And do not forget do remove it
    // once you do not need it anymore.

    input.onchange = function () {
      var file = this.files[0]

      var reader = new FileReader()
      reader.onload = function () {
        // Note: Now we need to register the blob in TinyMCEs image blob
        // registry. In the next release this part hopefully won't be
        // necessary, as we are looking to handle it internally.
        var id = 'blobid' + (new Date()).getTime()
        var blobCache = window.tinymce.activeEditor.editorUpload.blobCache
        var base64 = reader.result.split(',')[1]
        var blobInfo = blobCache.create(id, file, base64)
        blobCache.add(blobInfo)

        // call the callback and populate the Title field with the file name
        cb(blobInfo.blobUri(), { title: file.name })
      }
      reader.readAsDataURL(file)
    }

    input.click()
  }
}



// WEBPACK FOOTER //
// ./src/mixin/global/constants.js